export default __webpack_public_path__ + "static/media/info-1.c3bd767f.png";